import React from 'react';
import { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import Devicelist from "./dashboard/devicelist";

function ApplianceMonitorHome() {

    const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
    const [isAccessTokenReady, setIsAccessTokenReady] = useState(false);

    useEffect(() => {
        let isMounted = true;

        if (!isAuthenticated) {
            setIsAccessTokenReady(false);
            return () => {
                isMounted = false;
            };
        }

        setIsAccessTokenReady(false);

        const loadAccessToken = async () => {
            try {
                await getAccessTokenSilently();
                if (isMounted) {
                    setIsAccessTokenReady(true);
                }
            } catch (error) {
                if (isMounted) {
                    setIsAccessTokenReady(false);
                }
            }
        };

        loadAccessToken();

        return () => {
            isMounted = false;
        };
    }, [getAccessTokenSilently, isAuthenticated]);

    if (isLoading) {
        return null;
    }

    return (
        <React.Fragment>

            {
                isAuthenticated ? (
                    isAccessTokenReady ? <Devicelist /> : null
                ) : (
                    <main className="app-page">
                        <section className="app-page-content">
                            <div className="app-empty-state">
                                Please login
                            </div>
                        </section>
                    </main>
                )
            }

        </React.Fragment>
    );

}

export default ApplianceMonitorHome;
